var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('a-tag',{attrs:{"color":_vm.tagColor}},[_vm._v(_vm._s(_vm.tagText))]),(_vm.reason)?_c('span',[_vm._v(_vm._s(_vm.reason))]):_vm._e(),(_vm.retry)?_c('a-button',{attrs:{"icon":"shopping","type":"link","size":"small"},on:{"click":_vm.retryClick}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }